import { cn } from '@/lib/utils';
import { RESULTADOS, numerosDelPeriodo } from '../../lib/corridas';
import type { ResumenDelPeriodo } from '../../types/corridas.types';

/** Los diez números del período (maqueta: `.summary`). */
export function NumerosDelPeriodo({ resumen }: { resumen: ResumenDelPeriodo }) {
  return (
    <dl
      data-testid="numeros-del-periodo"
      className="grid grid-cols-2 overflow-hidden rounded-tarjeta border bg-card shadow-sm sm:grid-cols-5"
    >
      {numerosDelPeriodo(resumen).map((n, i) => {
        const r = n.resultado ? RESULTADOS.find((x) => x.clave === n.resultado) : null;
        return (
          <div
            key={n.texto}
            data-caja
            title={n.ayuda}
            className={cn('min-w-0 border-b border-r p-3', i >= 8 && 'bg-muted/40')}
          >
            <dd className="text-lg font-semibold tabular-nums [overflow-wrap:anywhere]">
              {n.valor}
            </dd>
            <dt className="mt-0.5 flex min-w-0 items-center gap-1.5 text-xs text-muted-foreground">
              {r && (
                <span aria-hidden="true" className={cn('h-2 w-2 shrink-0 rounded-full', r.fondo)} />
              )}
              <span className="min-w-0 [overflow-wrap:anywhere]">{n.texto}</span>
            </dt>
            {n.nota && (
              <dd className="mt-0.5 text-xs text-muted-foreground [overflow-wrap:anywhere]">
                {n.nota}
              </dd>
            )}
          </div>
        );
      })}
    </dl>
  );
}
